// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"abec6df7","667":"26b9f47b","977":"661b2c60"}[chunkId] + ".chunk.js";
};